import { render, staticRenderFns } from "./ProductSelected.vue?vue&type=template&id=1ac39702&scoped=true&"
import script from "./ProductSelected.vue?vue&type=script&lang=js&"
export * from "./ProductSelected.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelected.vue?vue&type=style&index=0&id=1ac39702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac39702",
  null
  
)

export default component.exports